import React from "react";
import { Flex, Spin } from "antd";

export const Spinner: React.FC = () => (
  <Flex align="center" gap="middle">
    <Spin size="small" />
  </Flex>
);

// You can use any loader component/library you prefer

export const Loader = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "149.25vh", //100vh
      }}
    >
      <Spin size="large" />
    </div>
  );
};

export default Loader;
